import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { Passback } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PassbackService {

  private path = '/passbacks';

  constructor(private http: AlloxApiService) { }

  public search() {
    return this.http.get<[]>(this.path).pipe(
      map(objs => objs.map(obj => new Passback(obj)))
    );
  }
}
